import { ChevronDown, Search } from './Icons'

type Props = {
  query: string
  onQueryChange: (value: string) => void
  role: string
}

export function Topbar({ query, onQueryChange, role }: Props) {
  return (
    <header className="topbar">
      <label className="global-search">
        <Search size={17} aria-hidden="true" />
        <input
          aria-label="Global search"
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Email, license key, purchase ID"
        />
        <kbd>⌘ K</kbd>
      </label>
      <button className="admin-menu" type="button">
        <span className="avatar">AC</span>
        <span className="capitalize">{role || 'Admin'}</span>
        <ChevronDown size={14} />
      </button>
    </header>
  )
}
